import * as React from 'react';

function ModerateIcon(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
        fill="#F28A00"
      />
      <path
        d="M13.843 18.405a1.895 1.895 0 1 1-3.791.001 1.895 1.895 0 0 1 3.79-.001ZM30.032 18.405a1.895 1.895 0 1 1-3.79.001 1.895 1.895 0 0 1 3.79-.001ZM24.43 29.49a.804.804 0 0 1-.447-.135c-1.438-.954-2.723-1.42-3.921-1.42-1.651 0-3.103.765-4.03 1.41a.806.806 0 1 1-.918-1.325c1.115-.777 2.88-1.698 4.95-1.698 1.528 0 3.103.552 4.816 1.689a.808.808 0 0 1 .226 1.12.82.82 0 0 1-.676.358Z"
        fill="#2B2523"
      />
    </svg>
  );
}

export default ModerateIcon;
